// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_es_mjs":"637303f2ce7d00e4","node_modules_canvg_lib_index_es_js":"feca9440336e9411","node_modules_angular_animations_fesm2022_browser_mjs":"dbf5ba516254c579"}[chunkId] + ".js";
};